import React, { PropTypes, PureComponent } from 'react';
import PlayButton from './controls/PlayButton';
import CurrentTimeLabel from './controls/CurrentTimeLabel';
import Slider from './controls/Slider';
import RefreshButton from './controls/RefreshButton';
import ProgressBar from './controls/ProgressBar';

import './controls.scss';

class TimeNavigation extends PureComponent {
  render() {
    const { props } = this;
    return (
      <div className="mt-time-navigation-container timinghandler">
        <PlayButton playHandler={props.playHandler} isPlaying={props.isPlaying} />
        <CurrentTimeLabel
          visibleTimestamp={props.visibleTimestamp}
          format={props.format}
          prognoseAfterTimestamp={props.timeNavigation.prognoseAfterTimestamp}
          show_date={this.props.show_date}
          show_time={this.props.show_time}
        />
        <div className="mt-control-item mt-slider-container">
          <Slider
            initial={props.timeNavigation.initial}
            min={props.timeNavigation.min}
            max={props.timeNavigation.max}
            step={props.timeNavigation.step}
            handler={props.handler}
            format={props.format}
            visibleTimestamp={props.visibleTimestamp}
            isPlaying={props.isPlaying}
            prognoseAfterTimestamp={props.timeNavigation.prognoseAfterTimestamp}
          />
          <ProgressBar
            tilesLoaded={props.tilesLoaded}
            prognose={props.timeNavigation.prognose}
          />
        </div>
        {this.props.children}
        <RefreshButton />
      </div>
    );
  }
}

TimeNavigation.propTypes = {
  props: PropTypes.object,
  products: PropTypes.array
};

export default TimeNavigation;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/index.js
 **/